<template lang="html">
  <li class="col-lg-2 col-md-4 col-sm-6 col-6 profile-favorite-box">

    <router-link :to="{path: linkValue}" v-if="internalLink">
      <img :src="imgSrc" class="profile-favorite-box-img" :alt="'Billede af '+childData.name" :aria-label="'Billede af '+childData.name"/>
      <div class="profile-favorite-box-text-div text-truncate">
        <span>{{ childData.name }}</span><br>
        <em v-if="childData.tagName" class="font-italic">{{ childData.tagName }}</em>
      </div>
    </router-link>

    <a :href="linkValue" v-else>
      <img :src="imgSrc" class="profile-favorite-box-img" :alt="'Billede af '+childData.name" :aria-label="'Billede af '+childData.name"/>
      <div class="profile-favorite-box-text-div text-truncate">
        <span>{{ childData.name }}</span><br>
        <em v-if="childData.tagName" class="font-italic">{{ childData.tagName }}</em>
      </div>
    </a>

    <span class="like-icon" role="button" :aria-label="'Fjern '+childData.name+' fra favoritter'" @click="likeController" v-if="!removeLikeFunction" tabindex="0">
      <span :class="['material-icons', 'like-icon-i', {'pink-text' : isLiked}]" aria-hidden="true">favorite_border</span>
    </span>

  </li>
</template>

<script>
import Profile from '@/assets/profile/Profile.js'
import { EventBus } from '@/main.js'

export default {
  data() {
    return {
      linkValue: '',
      imgSrc: '',
      itemId: false,
      isLiked: false,
      likeOptions: false,
      internalLink: true,
    }
  },
  props: {
    childData: {},
    removeLikeFunction: {
      default: false,
    }
  },
  created() {
    this.createData();
  },
  updated() {
    this.createData();
  },
  methods: {
    createData() {
      this.imgSrc = (this.childData.itemBroke || this.childData.archived) ? '/img/brokenlink.jpg' : this.childData.image;

      if(this.childData.type == 'place') {
        //this.linkValue = (this.childData.archived) ? '/notfound/place/'+this.childData.value+'/archived' : '/tag/'+this.childData.tagId+'/place/'+this.childData.value;
        this.linkValue = (this.childData.archived || this.childData.itemBroke) ? '/notfound/' : '/tag/'+this.childData.tagId+'/place/'+this.childData.value;
        this.likeOptions = {type: this.childData.type, id: this.childData.value, name: this.childData.name, tagId: this.childData.tagId, img: this.childData.image};
      }
      else if(this.childData.type == 'link') {
        if(this.childData.value.indexOf('odenserundt.dk') != -1) {
          let split = this.$props.childData.value.split('odenserundt.dk');
          this.linkValue = split[1];
        }
        else {
          this.internalLink = false;
          this.linkValue = this.childData.value;
        }
        this.likeOptions = {type: this.childData.type, id: this.childData.linkId, name: this.childData.name, http: this.childData.value, img: this.childData.image};
      }
      else if(this.childData.type == 'tag') {
        //this.linkValue = (this.childData.archived) ? '/notfound/tag/'+this.childData.value+'/archived' : '/tag/'+this.childData.value;
        this.linkValue = (this.childData.archived || this.childData.itemBroke) ? '/notfound/' : '/tag/'+this.childData.value;
        this.likeOptions = {type: this.childData.type, id: this.childData.value, name: this.childData.name, img: this.childData.image};
      }
      else if(this.childData.type == 'group') {
        //this.linkValue = (this.childData.archived) ? '/notfound/group/'+this.childData.value+'/archived' : '/group/'+this.childData.value;
        this.linkValue = (this.childData.archived || this.childData.itemBroke) ? '/notfound/' : '/group/'+this.childData.value;
        this.likeOptions = {type: this.childData.type, id: this.childData.value, name: this.childData.name, img: this.childData.image};
      }
      this.itemId = (this.childData.type == 'link') ? this.childData.linkId : this.childData.value;
      this.isLiked = Profile.checkIfItemIsLiked(this.childData.type, this.itemId);
    },
    likeController() {
      if(Profile.loggedIn) {
        var isLiked = Profile.checkIfItemIsLiked(this.childData.type, this.itemId);
        if(!isLiked) {
          Profile.like(this.likeOptions);
          this.isLiked = true;
          this.$emit('dataChanged');
        }
        else if(isLiked) {
          var obj = {message: 'Vil du fjerne '+this.childData.name+' fra dine favoritter?', cancelBtnText: 'Nej', btnText: 'Ja', callbackType: 'function', callback: this.unlikeDone};
          EventBus.$emit('openMessageBox', obj);
        }
      }
      else {
        this.$router.push('/login');
      }
    },
    unlikeDone() {
      Profile.unlike(this.childData.type, this.itemId);
      this.isLiked = false;
      this.$emit('dataChanged');
    },
  }
}
</script>

<style lang="css" scoped>
  .profile-favorite-box {
  	display: inline-block;
    position: relative;
  	padding-left: 5px;
  	padding-right: 5px;
  	margin-bottom: 10px;
  }

  .profile-favorite-box-img {
  	width: 100%;
    -webkit-filter: grayscale(10%);
    filter: grayscale(10%);
  }

  .profile-favorite-box-text-div {
    width: 100%;
    height: 40px;
    color: #424242 !important;
  	padding-left: 3px;
  	letter-spacing: 0.5px;
  	background-color: #fdfdfd;
  	box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
  }
</style>
